import Repository from "./Repository";

const CREATE_ORDER_PAYMENT = "orderPayment";
const CREATE_PAYMENT = "create";
const CREATE_FREE_PAYMENT = "createFree";
const UPDATE_PAYMENT = "update";
const GET_ALL_PAYMENT = "getAllPayments";

export default {
  create_order_payment(payload) {
    return Repository.post(transformRoute(CREATE_ORDER_PAYMENT), payload);
  },
  create_payment(payload) {
    return Repository.post(transformRoute(CREATE_PAYMENT), payload);
  },
  update_payment(payload) {
    return Repository.post(transformRoute(UPDATE_PAYMENT), payload);
  },
  getAllPayments(payload) {
    return Repository.post(transformRoute(GET_ALL_PAYMENT), payload);
  },
  createFreePayment(payload) {
    return Repository.post(transformRoute(CREATE_FREE_PAYMENT), payload);
  },
};

const transformRoute = (route) => {
  return `payment/${route}`;
};
